import CartItem from 'emun.cart/cart-item.model'
import AutoQuery from 'servicestack/auto-query/auto-query'
import resolve from 'ioc/resolve'

class ConsumerOrderController  {
    constructor(createAutoQuery) {
        let $ctrl = this;
        let options = {
            url: `Cart/${this.orderId}.json?IncludeProducts=1`,
            autoLoad: true,
            onLoaded: this.orderLoaded,
            onEmpty() {
                this.query = new AutoQuery({
                    url: 'QueryCarts.json?IncludeProducts=1&OriginalOrderNumber=' + this.orderId,
                    autoLoad: true,
                    onLoaded: args => {
                        args.first.items = args.first.items.map(item => new CartItem(item));
                        this.order = args.first;
                    }
                });
            }
        };
        this.query = new AutoQuery(options);
        let $rootScope = resolve('$rootScope');
        $rootScope.$on('cartRefunded', function() {
            $ctrl.query.load(true);
        });
        $rootScope.$on('orderCancelled', function() {
            $ctrl.query.load(true);
        });
    }
    load(){return this.query.load.apply(this.query, arguments);}

    orderLoaded(args){
        this.order = args.first;
        this.order.items = this.order.items.map(i => new CartItem(i));
    }

    $onDestroy() {
        this.query.dispose();
    }
}

class ConsumerOrder{
    constructor(){
        this.require= {
            container: '^consumerContainer'
        };
        this.bindings= {
            consumerId: '@',
            orderId: '@'
        };
        this.controller = ConsumerOrderController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumer-order.html'
    }
}

angular.module('emun.consumer').component('consumerOrder', new ConsumerOrder());

export default ConsumerOrder